<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 24px">
          <el-breadcrumb-item :to="{ name: 'formalProjectSitesManage' }"
            style="font-size: 24px">项目点管理列表</el-breadcrumb-item>
          <el-breadcrumb-item style="font-size: 24px">基础配置</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-tag effect="dark" size="medium">{{ this.projectInfo.NAME }}</el-tag>
      <!-- <el-tag effect="plain" size="medium">{{this.projectInfo.TC_NAME}}</el-tag> -->
    </el-row>
    <el-row v-loading="loading" style="margin-top: 0px">
      <table stripe style="margin-top: 10px; width: 100%;">
        <thead style="text-align: left">
          <th style="width: 15%"><b>设置</b></th>
          <th style="width: 55%"><b>说明</b></th>
          <th style="width: 25%"><b>选项</b></th>
          <th style="width: 5%"><b>确认设置</b></th>
        </thead>
        <tr>
          <td>下单时是否显示商品描述</td>
          <td>
            显示：下单时会显示该商品的描述<br>
            不显示：下单时不会显示该商品的描述
          </td>
          <td>
            <el-form :model="settingForm" ref="settingForm">
              <el-radio-group v-model="settingForm.IS_SHOW_DESCRIPTION">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="0">不显示</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitSetting">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>下单时是否显示供应商</td>
          <td>
            显示：下单时会显示提供该商品的供应商<br>
            不显示：下单时不会显示提供该商品的供应商
          </td>
          <td>
            <el-form :model="settingForm" ref="settingForm">
              <el-radio-group v-model="settingForm.IS_SHOW_SUPPLIER">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="0">不显示</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitSetting">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>订单打印设置</td>
          <td>
            打印出的订单是否有价格列
          </td>
          <td>
            <el-form :model="printForm" ref="printForm">
              <el-radio-group v-model="printForm.SHOW_PRICE">
                <el-radio :label="0">不带价格</el-radio>
                <el-radio :label="1">带价格</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitPrint">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>下单是否需要采购部审批</td>
          <td>
            需要：下单需要经过采购部审批<br>
            不需要：下单无需审批，直接下单到供应商
          </td>
          <td>
            <el-form :model="orderCheckForm" ref="orderCheckForm">
              <el-radio-group v-model="orderCheckForm.IS_ORDER_AUDIT">
                <el-radio :label="1">需要</el-radio>
                <el-radio :label="0">不需要</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitOrderCheck">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>应急订单是否审批</td>
          <td>
            需要：应急订单需要经过采购部审批<br>
            不需要：应急订单无需审批，直接下单到供应商
          </td>
          <td>
            <el-form :model="emergencyForm" ref="emergencyForm">
              <el-radio-group v-model="emergencyForm.IS_ERG_ORDER_AUDIT">
                <el-radio :label="1">需要</el-radio>
                <el-radio :label="0">不需要</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitEmergency">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>补单是否需要采购部审批</td>
          <td>
            需要：补单需要经过采购部审批<br>
            不需要：补单无需审批，直接下单到供应商
          </td>
          <td>
            <el-form :model="settingForm" ref="settingForm">
              <el-radio-group v-model="settingForm.IS_SUPPLYORDER_AUDIT">
                <el-radio :label="1">需要</el-radio>
                <el-radio :label="0">不需要</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitSetting">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>补单是否需要财务部审批</td>
          <td>
            需要：补单需要经过财务部审批<br>
            不需要：补单无需审批，直接下单到供应商
          </td>
          <td>
            <el-form :model="settingForm" ref="settingForm">
              <el-radio-group v-model="settingForm.IS_FINANCE_SUPPLYORDER_AUDIT">
                <el-radio :label="1">需要</el-radio>
                <el-radio :label="0">不需要</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitSetting">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>项目经理是否能够修改订单数量、出库</td>
          <td>
            默认为"是"<br>
            设置为否则项目经理无法进行修改订单数量、出库操作
          </td>
          <td>
            <el-form :model="settingForm" ref="settingForm">
              <el-radio-group v-model="settingForm.IS_NONMODIFY">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitSetting">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>退库是否需要项目经理审核</td>
          <td>
            需要：退库需要经过项目经理审批<br>
            不需要：退库无需审批，项目点可直接退库
          </td>
          <td>
            <el-form :model="settingForm" ref="settingForm">
              <el-radio-group v-model="settingForm.IS_RETURN_AUDIT">
                <el-radio :label="1">需要</el-radio>
                <el-radio :label="0">不需要</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitSetting">配置</el-button>
          </td>
        </tr>
        <tr>
          <td>收入上报设置</td>
          <td> 默认为"不区分客户"</td>
          <td>
            <el-form :model="coumStatus" ref="coumStatus">
              <el-form-item label="收入上报设置">
                <el-radio-group v-model="coumStatus.MULTIPLE">
                  <el-radio :label="1">区分客户</el-radio>
                  <el-radio :label="0">不区分客户</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="月结表上报设置设置" v-if="this.coumStatus.MULTIPLE == 1">
                <el-radio-group v-model="coumStatus.IS_REPORT_FEE_DISTINGUISH_CLIENT">
                  <el-radio :label="1">区分客户</el-radio>
                  <el-radio :label="0">不区分客户</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开票额度设置" v-if="
                this.coumStatus.MULTIPLE == 1 &&
                this.coumStatus.IS_REPORT_FEE_DISTINGUISH_CLIENT == 1
              ">
                <el-radio-group v-model="coumStatus.IS_ISSUE_INVOICE_DISTINGUISH_CLIENT">
                  <el-radio :label="1">区分客户</el-radio>
                  <el-radio :label="0">不区分客户</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="submitCoumStatus">配置</el-button>
          </td>
        </tr>
        <!-- <tr>
          <td>退货是否自动审批</td>
          <td>
            设置后对于项目点发起的退货，若采购部已审核通过，<br>
            则在设置天数后自动审批退货
          </td>
          <td>
            <el-form :model="DeadlineForm" ref="DeadlineForm">
              <el-radio-group v-model="DeadlineForm.IS_AUTO_APPROVE_RETURNS">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" v-preventReClick @click="submitReturnApproval">提交</el-button>
          </td>
        </tr> -->
        <tr>
          <td>下单是否合并</td>
          <td>
            合并：若下单时已存在相同日期、档口、供应商的订单，则与该订单合并<br>
            不合并：每次下单均创建一张新订单
          </td>
          <td>
            <el-form :model="setAddOrderForm" ref="setAddOrderForm">
              <el-radio-group v-model="setAddOrderForm.IS_MERGE_ORDER">
                <el-radio :label="1">合并</el-radio>
                <el-radio :label="0">不合并</el-radio>
              </el-radio-group>
            </el-form>
          </td>
          <td>
            <el-button type="text" @click="setAddOrder">配置</el-button>
          </td>
        </tr>
      </table>
    </el-row>
    <!-- 退货审批填写是时拉取模态框 -->
    <el-dialog :visible.sync="isReturnDialog" title="退货自动审批配置" width="400px" center :close-on-click-modal="false">
      <el-form ref="DeadlineFormReturn" v-model="DeadlineFormReturn">
        <!-- <el-form-item label="自动审批时间">
          <el-time-select v-model="DeadlineFormReturn.orderDeadlineReturn" :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '23:00'
            }" placeholder="选择时间"></el-time-select>
        </el-form-item> -->
        <el-form-item label="自动审批几天后">
          <el-input v-model="DeadlineFormReturn.DAYS_OF_AUTO_APPROVE_RETURNS"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <!-- <el-button class="operate-btn" @click="closeDeadlineReturn">取消</el-button> -->
        <el-button class="operate-btn" @click="submitDeadlineReturn" :loading="loading10">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      loading10: false,
      isReturnDialog: false,
      DeadlineFormReturn: {
        orderDeadlineReturn: '',
      },
      projectInfo: {},
      loading: false,
      // 导入订单
      importOrderForm: {
        excel: 'tmp',
      },
      orderList: [],
      order_name: '',
      // 订单预处理
      orderPreprocess: {
        excel: 'tmp',
      },
      preprocessList: [],
      preprocess_name: '',
      // 非工作日是否可以修改订单
      dealForm: {
        allow: '',
      },
      // 下单是否合并
      setAddOrderForm: {
        IS_MERGE_ORDER: '',
      },
      // 下单是否需要采购部审批
      orderCheckForm: {
        IS_ORDER_AUDIT: '',
      },
      // 应急订单是否需要审批
      emergencyForm: {
        IS_ERG_ORDER_AUDIT: '',
      },
      // 审批后是否可以继续下单
      continueOrderForm: {
        ORDER_AFTER_AUDIT: '',
      },
      // 设置自动审批时间
      approvalTimeForm: {
        auditDeadLine: '',
      },
      // 仓库配置
      wareForm: {
        IS_WAREHOUSE_USE_BATCH: 0,
      },
      // 导入库存、库存预处理
      exportStockForm: {
        excel: 'tmp',
      },
      addSKUForm: {
        excel: 'tmp',
      },
      fileList: [],
      file_name: '',
      // 入库是否需要生产日期
      pruductStatus: {
        IS_NEED_INPUT_INFO: '',
      },
      // 盘库审批
      wareHouseForm: {
        isYes: '',
      },
      // 项目点状态
      statusForm: {
        status: '',
      },
      // 月结表置零
      addForm: {},
      // 上报方式
      getForm: {
        resource: '',
      },
      // 设置刷卡时间
      cardForm: {
        cardTime: '',
      },
      // 开票公司匹配
      TCPPForm: {
        TC_DATA: '',
      },
      companyList: [],
      // 打印设置
      printForm: {
        SHOW_PRICE: '',
      },
      // 支付配置
      weChatPayForm: {
        wechat: '',
      },
      alipayPayForm: {
        alipay: '',
      },
      // 开票限制，应急、现金采购是否需要票据
      paperForm: {
        INVOICE_LIMIT: '',
        IS_SP_ORDER_CERTIFICATE: '',
      },
      // 修改成本日显示
      changeForm: {
        SHOW_BALANCE_DAY: '',
      },
      // 复制虚拟项目
      copyVirtualForm: {
        TC_ID: '',
      },
      // 切换供应关系
      ChangeSupplyRelationsForm: {
        AUTO_SWITCH_SUPPLIER: '',
        EMAIL: '',
        SWITCH_SUPPLIER_DAYS: '',
        options: [
          { value: '7', label: '一周' },
          { value: '14', label: '二周' },
          { value: '21', label: '三周' },
          { value: '28', label: '四周' },
          { value: '35', label: '五周' },
        ],
      },
      // 收入上报设置
      coumStatus: {
        MULTIPLE: '',
        IS_REPORT_FEE_DISTINGUISH_CLIENT: '',
        IS_ISSUE_INVOICE_DISTINGUISH_CLIENT: '',
      },
      // 切换团餐公司
      changeTCform: {
        TC_ID: '',
      },
      changeTClist: [],
      // 配置
      settingForm: {
        CAN_CHANGE_PRICE: '',
        IS_SHOW_SUPPLIER: '',
        IS_SHOW_DESCRIPTION: '',
        IS_SUPPLYORDER_AUDIT: '',
        IS_NONMODIFY: '',
        IS_RETURN_AUDIT: '',
        IS_EXIST_MANAGER_AUDIT_DEADLINE: '',
        IS_FINANCE_SUPPLYORDER_AUDIT: '',
        MANAGER_AUDIT_DEADLINE: '',
      },
      DeadlineForm: {},
      projectSitesListData: [],
    };
  },
  methods: {
    // 下单是否合并
    setAddOrder() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 15,
        PROJECT_ID: this.projectInfo.ID,
        IS_MERGE_ORDER: this.setAddOrderForm.IS_MERGE_ORDER,
      };
      http
        .post(params)
        .then((result) => {
          // this.querySearch();
          this.$message.show({ text: '操作成功', type: 'success' });
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 下单是否需要采购部审批
    submitOrderCheck() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 13,
        PROJECT_ID: this.projectInfo.ID,
        IS_ORDER_AUDIT: this.orderCheckForm.IS_ORDER_AUDIT,
      };
      http
        .post(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          // this.querySearch();
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 应急订单是否需要审批
    submitEmergency() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 14,
        PROJECT_ID: this.projectInfo.ID,
        IS_ERG_ORDER_AUDIT: this.emergencyForm.IS_ERG_ORDER_AUDIT,
      };
      http
        .post(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          // this.querySearch();
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 打印设置
    submitPrint() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 12,
        SHOW_PRICE: this.printForm.SHOW_PRICE,
        PROJECT_ID: this.projectInfo.ID,
      };
      http
        .post(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          // this.querySearch();
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 收入上报设置
    submitCoumStatus() {
      if (this.coumStatus.MULTIPLE == 0) {
        this.coumStatus.IS_REPORT_FEE_DISTINGUISH_CLIENT = 0;
        this.coumStatus.IS_ISSUE_INVOICE_DISTINGUISH_CLIENT = 0;
      }
      if (this.coumStatus.IS_REPORT_FEE_DISTINGUISH_CLIENT == 0) {
        this.coumStatus.IS_ISSUE_INVOICE_DISTINGUISH_CLIENT = 0;
      }
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 17,
        PROJECT_ID: this.projectInfo.ID,
        MULTIPLE: this.coumStatus.MULTIPLE,
        IS_REPORT_FEE_DISTINGUISH_CLIENT:
          this.coumStatus.IS_REPORT_FEE_DISTINGUISH_CLIENT,
        IS_ISSUE_INVOICE_DISTINGUISH_CLIENT:
          this.coumStatus.IS_ISSUE_INVOICE_DISTINGUISH_CLIENT,
      };
      http
        .post(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryProjectSitesListData();
          // this.querySearch();
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 提交配置
    submitSetting() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 11,
        PROJECT_ID: this.projectInfo.ID,
        IS_SHOW_SUPPLIER: this.settingForm.IS_SHOW_SUPPLIER,
        IS_SHOW_DESCRIPTION: this.settingForm.IS_SHOW_DESCRIPTION,
        IS_SUPPLYORDER_AUDIT: this.settingForm.IS_SUPPLYORDER_AUDIT,
        IS_NONMODIFY: this.settingForm.IS_NONMODIFY,
        IS_RETURN_AUDIT: this.settingForm.IS_RETURN_AUDIT,
        IS_FINANCE_SUPPLYORDER_AUDIT: this.settingForm.IS_FINANCE_SUPPLYORDER_AUDIT,
      };
      http
        .post(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          // this.querySearch();
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 退货自动审批
    submitReturnApproval() {
      console.log(this.DeadlineForm.IS_AUTO_APPROVE_RETURNS);
      if (this.DeadlineForm.IS_AUTO_APPROVE_RETURNS == 0) {
        const params = {
          SERVICE_ID: '10005',
          OTYPE: 16,
          SUPPLIER_ID: this.DeadlineForm.SUPPLIER_ID,
          TC_ID: this.DeadlineForm.TC_ID,
          IS_AUTO_APPROVE_RETURNS: this.DeadlineForm.IS_AUTO_APPROVE_RETURNS,
        };
        http
          .post(params)
          .then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
          })
          .catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      } else {
        this.isReturnDialog = true;
      }
    },
    // 退货是否自动审批确认的模态框修改
    submitDeadlineReturn() {
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 34,
        SUPPLIER_ID: this.DeadlineForm.SUPPLIER_ID,
        TC_ID: this.DeadlineForm.TC_ID,
        IS_AUTO_APPROVE_RETURNS: this.DeadlineForm.IS_AUTO_APPROVE_RETURNS,
        DAYS_OF_AUTO_APPROVE_RETURNS: this.DeadlineFormReturn.DAYS_OF_AUTO_APPROVE_RETURNS,
      };
      this.loading10 = true;
      http
        .post(params)
        .then((result) => {
          this.loading10 = false;
          this.$message.show({ text: '操作成功', type: 'success' });
          this.isReturnDialog = false;
        })
        .catch((error) => {
          this.loading10 = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取项目点列表
    queryProjectSitesListData() {
      const data = {
        SERVICE_ID: '10001',
        OTYPE: 33,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PROJECT_ID: this.projectInfo.ID,
        TC_ID: sessionStorage.getItem('companyId'),
        // PAGEINDEX: this.currentPage - 1,
        // PAGESIZE: this.pageSize,
      };
      http.post(data).then((res) => {
        if (res.length != 0) {
          this.projectSitesListData = res[0];
          this.coumStatus.MULTIPLE = this.projectSitesListData.MULTIPLE;
        } else {
          this.projectSitesListData = [];
          this.coumStatus.MULTIPLE = 0;
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
  },
  created() {
    if (sessionStorage.getItem('projectInfo')) {
      // this.projectInfo.TC_ID = JSON.parse(sessionStorage.getItem('projectInfo')).COMPANY;
      // this.projectInfo.PROJECT_NAME = JSON.parse(sessionStorage.getItem('projectInfo')).PROJECT_NAME;
      this.projectInfo = JSON.parse(sessionStorage.getItem('projectInfo'));
    }
    this.queryProjectSitesListData();
    // this.querySearch();
    this.setAddOrderForm.IS_MERGE_ORDER = this.projectInfo.IS_MERGE_ORDER;
    this.orderCheckForm.IS_ORDER_AUDIT = this.projectInfo.IS_ORDER_AUDIT;
    this.emergencyForm.IS_ERG_ORDER_AUDIT = this.projectInfo.IS_ERG_ORDER_AUDIT;
    this.continueOrderForm.ORDER_AFTER_AUDIT = this.projectInfo.ORDER_AFTER_AUDIT;
    this.approvalTimeForm.auditDeadLine = this.projectInfo.AUDIT_DEADLINE;
    this.wareForm.IS_WAREHOUSE_USE_BATCH = this.projectInfo.IS_WAREHOUSE_USE_BATCH;
    this.pruductStatus.IS_NEED_INPUT_INFO = this.projectInfo.IS_NEED_INPUT_INFO;
    this.getForm.resource = this.projectInfo.IS_AUTO_INCOME;
    this.printForm.SHOW_PRICE = this.projectInfo.SHOW_PRICE;
    this.paperForm.INVOICE_LIMIT = this.projectInfo.INVOICE_LIMIT;
    this.changeForm.SHOW_BALANCE_DAY = this.projectInfo.SHOW_BALANCE_DAY;
    this.ChangeSupplyRelationsForm.AUTO_SWITCH_SUPPLIER = this.projectInfo.AUTO_SWITCH_SUPPLIER;
    this.ChangeSupplyRelationsForm.EMAIL = this.projectInfo.EMAIL;
    this.ChangeSupplyRelationsForm.SWITCH_SUPPLIER_DAYS = this.projectInfo.SWITCH_SUPPLIER_DAYS;
    this.coumStatus.MULTIPLE = this.projectInfo.MULTIPLE;
    this.coumStatus.IS_REPORT_FEE_DISTINGUISH_CLIENT = this.projectInfo.IS_REPORT_FEE_DISTINGUISH_CLIENT;
    this.coumStatus.IS_ISSUE_INVOICE_DISTINGUISH_CLIENT = this.projectInfo.IS_ISSUE_INVOICE_DISTINGUISH_CLIENT;
    this.changeTCform.TC_ID = this.projectInfo.TC_ID;
    this.settingForm.CAN_CHANGE_PRICE = this.projectInfo.CAN_CHANGE_PRICE;
    this.settingForm.IS_SHOW_SUPPLIER = this.projectInfo.IS_SHOW_SUPPLIER;
    this.settingForm.IS_SHOW_DESCRIPTION = this.projectInfo.IS_SHOW_DESCRIPTION;
    this.settingForm.IS_SUPPLYORDER_AUDIT = this.projectInfo.IS_SUPPLYORDER_AUDIT;
    this.settingForm.IS_NONMODIFY = this.projectInfo.IS_NONMODIFY;
    this.settingForm.IS_RETURN_AUDIT = this.projectInfo.IS_RETURN_AUDIT;
    this.settingForm.IS_EXIST_MANAGER_AUDIT_DEADLINE = this.projectInfo.IS_EXIST_MANAGER_AUDIT_DEADLINE;
    this.settingForm.MANAGER_AUDIT_DEADLINE = this.projectInfo.MANAGER_AUDIT_DEADLINE;
    this.settingForm.IS_FINANCE_SUPPLYORDER_AUDIT = this.projectInfo.IS_FINANCE_SUPPLYORDER_AUDIT;
    // this.checkWareHouseConfig();
    // this.setCardTime();
    // this.queryCompany();
    // this.payConfig();
    // this.changeTC();
    // this.getAlipay();
    // this.getWhcat();
  },
  updated() {
    const rows = document.querySelectorAll('tr');
    for (let index = 1; index < rows.length; index += 2) {
      rows[index].className = 'even';
    }
  },
};

</script>
<style scoped>
table,
th,
td {
  border: solid 1px #ebeef5;
  border-collapse: collapse;
  font: 12px 'Avenir', Helvetica, Arial, sans-serif;
  padding: 8px 10px;
}

th {
  font-weight: 500;
}

thead {
  color: #909399;
  height: 40px;
}

td,
.el-radio /deep/ .el-radio__label,
.el-form-item /deep/ .el-form-item__label,
el-button {
  color: #606266;
  font: 12px 'Avenir', Helvetica, Arial, sans-serif;
}

.el-input,
.el-input /deep/ .el-input__inner,
.el-select /deep/ .el-input__inner,
.el-date-editor /deep/ .el-date-editor--time-select {
  width: 178px
}

td {
  line-height: 40px;
}

.el-radio /deep/ .el-radio__label {
  font: 12px Avenir, Helvetica, Arial, sans-serif;
}

.even {
  background: #FAFAFA;
}

tr:hover {
  background: #F5F7FA;
}

.el-form-item {
  margin-bottom: 0px
}

.el-form-item.is-error {
  margin-bottom: 5px
}

.el-form-item /deep/ .el-form-item__label {
  text-align: justify;
  text-align-last: justify;
  width: 120px;
  padding-top: 5px;
}

.el-form-item /deep/ .el-form-item__label::after {
  content: '：';
  position: absolute;
}

.el-form,
.el-radio-group {
  line-height: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/basicConfiguration.vue